<template>
  <div>
    <Layout/>
    <div class="breadcrumb-container">
      <router-link to="/consejo">Tip's - Consejos de uso del sistema</router-link>
        > Tip {{ datoConsejo.idConsejo }}
    </div>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idConsejo" class="form-label">IdConsejo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idConsejo" name="idConsejo" v-model="datoConsejo.idConsejo" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoConsejo.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoConsejo.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="texto" class="form-label">Texto</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="texto" name="texto" v-model="datoConsejo.texto"></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoConsejo.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoConsejo.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarConsejo" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditConsejo" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">PerfilNombre</th>
          <th scope="col">Estado</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="consperf in datosPaginados" :key="consperf.idConsPerf">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(consperf.idConsPerf)" title="Editar">edit_square</i></td>
          <td>{{consperf.perfilNombre}}</td>
          <td>{{consperf.estado}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteConsejo(consperf.idConsPerf)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idConsPerf" class="form-label">IdConsPerf</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idConsPerf" name="idConsPerf" v-model="datoConsPerf.idConsPerf" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-1">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-4">
                    <select class="form-control" id="idPerfil" name="idPerfil" v-model="datoConsPerf.idPerfil">
                      <option v-for="perfil in perfils" :value="perfil.idPerfil" :key="perfil.idPerfil">
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" @click="asignarPerfil('1')">
                      <i class="material-icons" style="font-size:32px;color:darkblue; cursor: pointer;">manage_accounts</i>
                    </button>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" @click="asignarPerfil('2')">
                      <i class="material-icons" style="font-size:32px;color:darkblue; cursor: pointer;">person</i>
                    </button>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" @click="asignarPerfil('3')">
                      <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">supervisor_account</i>
                    </button>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" @click="asignarPerfil('4')">
                      <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">person</i>
                    </button>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" @click="asignarPerfil('5')">
                      <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">person_search</i>
                     </button>
                  </div>
                  <div class="col-1">
                    <button type="submit" class="btn btn-light" @click.prevent="guardarTodos" v-if="btnCrear_det" title="Guardar">
                      <i class="material-icons" style="font-size:32px;color:red; cursor: pointer;">groups</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
<!--
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idConsejo" class="form-label">IdConsejo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idConsejo" name="idConsejo" v-model="datoConsPerf.idConsejo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
-->
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarConsPerf" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditConsPerf" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      consejos : [],
      datoConsejo : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idConsejo: '',
// Variables master
// Variables details
      consperfs : [],
      datoConsPerf : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      perfils : [],
//      consejos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idConsejo = this.$route.params.p_idconsejo
    this.abrirEditar(this.p_idConsejo)
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchPerfils()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    asignarPerfil(idPerfil) {
      this.datoConsPerf.idPerfil = idPerfil;
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'texto'
      ];
      const requiredFieldsText = [
        'texto'
      ];
      return validarForm(this.datoConsejo, requiredFields, requiredFieldsText);
    },
    async guardarConsejo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/consejos', this.datoConsejo)
          swal("Correcto!", "Consejo creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditConsejo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/consejos', this.datoConsejo)
          swal("Correcto!", "Consejo creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoConsejo={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idConsejo){
      this.modalWindow = true
      if(idConsejo != null){    
           api.get('/vwconsejos/'+idConsejo).then(resp=>{
          this.datoConsejo = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarConsejo(){
      this.$router.push('/Consejo')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.consperfs.length / this.elementosPorPagina)
    },
/*    
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwconsperfs/nombre/'+this.nombreBusqueda).then(response=>{
          this.consperfs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.consperfs.slice(ini,fin);
        });
      }
    },
*/    
    getDataPaginaTodos(noPagina){
      api.get('/vwconsperfs/idconsejo/'+this.p_idConsejo).then(response=>{
      this.consperfs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.consperfs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'texto'
      ];
      const requiredFieldsText = [
        'texto'
      ];
      return validarForm(this.datoConsejo, requiredFields, requiredFieldsText);
    },
    async guardarConsPerf(){
      if(this.validarForm() === 1){
        try {
          this.datoConsPerf.idConsejo = this.datoConsejo.idConsejo;
          await api.post('/consperfs', this.datoConsPerf)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ConsPerf creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarTodos(){
      if(this.validarForm() === 1){
        try {
          this.datoConsPerf.idConsejo = this.datoConsejo.idConsejo;
          this.datoConsPerf.idPerfil = 3;
          await api.post('/consperfs', this.datoConsPerf)
          this.datoConsPerf.idPerfil = 4;
          await api.post('/consperfs', this.datoConsPerf)
          this.datoConsPerf.idPerfil = 5;
          await api.post('/consperfs', this.datoConsPerf)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ConsPerf creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditConsPerf(){
      if(this.validarForm() === 1){
        try {
          await api.post('/consperfs', this.datoConsPerf)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "ConsPerf creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoConsPerf={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idConsPerf){
      this.modalWindow = true
      if(idConsPerf != null){    
           api.get('/vwconsperfs/'+idConsPerf).then(resp=>{
          this.datoConsPerf = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    async deleteConsPerf (idConsPerf) {
      try{
        await api.delete('/consperfs/'+idConsPerf)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPerfils() {
      fetch('http://localhost:8080/api/v1/perfils')
        .then(response => response.json())
        .then(data => {
          this.perfils = data;
        })
        .catch(error => {
          console.error('Error fetching perfils:', error);
        });
    },
/*    
    fetchConsejos() {
      fetch('http://localhost:8080/api/v1/consejos')
        .then(response => response.json())
        .then(data => {
          this.consejos = data;
        })
        .catch(error => {
          console.error('Error fetching consejos:', error);
        });
    },
*/    
  },
}
</script>
